export const CARD_PADDING = 3
export const MAX_MESSAGE_CHARS = 1000
export const MAX_ATTACHMENTS = 10
